module.exports = __webpack_public_path__ + "img/tim_logotype.21908a1c.svg";